import axios from "axios";

import config from "./config";

export default class ExtratoCoparticipacoesService {
  static async getCoparticipacoes(dados) {
    const bodyFormData = new FormData();
    bodyFormData.append("servico", "utilizacaoByUser");
    bodyFormData.append("carteira",dados.carteira);
    bodyFormData.append("cpf",dados.cpf);
    bodyFormData.append("dataNascimento",dados.dataNascimento);
    bodyFormData.append("nomeMae",dados.nomeMae);
    bodyFormData.append("maeDesconhecida",dados.maeDesconhecida);
    let response = "";
    try {
      response = await axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
        return {status: false, error:err};
    }
    return response.data
  }
}
